<template>
  <d-card class="ubd-stats card-small h-100">
    <!-- Card Header -->
    <d-card-header class="border-bottom">
      <div class="float-left">
        <h6 class="m-0">{{title}}</h6>
      </div>
      <div
        v-html="htmlSubtitle"
        v-if="htmlSubtitle != null && htmlSubtitle != undefined && htmlSubtitle != ''"
        class="float-right"
      ></div>
    </d-card-header>

    <d-card-body class="d-flex flex-column">
      <!-- Chart -->
      <canvas width="100" ref="canvas" class="analytics-users-by-device mt-3 mb-4" />

      <!-- Legend  -->
      <div class="ubd-stats__legend w-10 m-auto pb-4">
        <div v-for="(label, idx) in computedLabels" :key="idx" class="ubd-stats__item">
          <div v-if="label.icon" v-html="label.icon" :style="{ color: label.iconColor }" />
          <span class="ubd-stats__stats">{{ label.title }}</span>
          <span class="ubd-stats__stats">{{ label.value | percentage }}</span>
        </div>
      </div>
    </d-card-body>

    <!-- Footer -->
    <d-card-footer class="border-top"></d-card-footer>
  </d-card>
</template>

<script>
import colors from "../../utils/colors";
import Chart from "../../utils/chart";
export default {
  name: "chart-card",
  props: {
    chartConfig: {
      type: Object,
      default() {
        return {};
      }
    },
    chartOptions: {
      type: Object,
      default() {
        return {};
      }
    },
    chartData: {
      type: Object,
      default() {
        return defaultChartData;
      }
    },
    title: {
      type: String,
      default: ""
    },
    htmlSubtitle: {
      type: String,
      default: ""
    }
  },
  computed: {
    computedLabels() {
      this.chartData.hoverBorderColor = colors.white.toRGBA(1);

      if (!this.chartData || typeof this.chartData.labels === "undefined") {
        return [];
      }

      const parsedChartData = this.chartData.labels.map((label, idx) => {
        const dataset = this.chartData.datasets[0];

        return {
          title: label,
          icon: dataset.icons[idx],
          iconColor: dataset.backgroundColor[idx],
          value: dataset.data[idx]
        };
      });

      return parsedChartData;
    }
  },
  mounted() {
    const chartConfig = {
      type: "pie",
      data: this.chartData,
      options: {
        ...{
          legend: false,
          cutoutPercentage: 50,
          tooltips: {
            enabled: false,
            mode: "index",
            position: "nearest"
          }
        },
        ...this.chartOptions
      }
    };
    new Chart(this.$refs.canvas, chartConfig);
  }
};
</script>


// WEBPACK FOOTER //
// src/components/common/chart-card.vue